"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateGetSessionResponseSchema = exports.CandidateAuthSessionSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
exports.CandidateAuthSessionSchema = zod_1.z.object({
    user: zod_1.z.object({
        candidateId: zod_1.z.string().uuid(),
        email: zod_1.z.string().email(),
        roles: schemas_1.RoleSchema.array(),
        uid: zod_1.z.string(),
    }),
});
exports.CandidateGetSessionResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.CandidateAuthSessionSchema);
